import React, {Component} from 'react';
import {connect} from 'react-redux';
import {Table, Input, Icon} from 'semantic-ui-react';
import {Actions} from '../../../common/actions';
import CodeInput from './codeInput';
import SaveIcon from './saveIcon';

class OrderElement extends Component {
  handleQuantityChange(index, event, data) {
    const {name, value} = data;
    this.props.changeProviderDetailElementValue(index, name, value);
  }

  handleEditClick(index) {
    if (!this.props.editing) {
      this.props.editProviderOrderDetailElement(index);
    }
  }

  handleDeleteClick(index) {
    if (!this.props.editing) {
      this.props.selectProviderOrderDetailElement(index);
    }
  }

  handleCancelClick(order, index) {
    if (order.isNew) {
      this.props.removeProviderOrderDetailElement(index);
      return;
    }

    this.props.cancelProviderOrderDetailElementEdition(index);
  }

  renderQuantity(order, index) {
    if (!order.active) {
      return order.partQuantity;
    }

    return (
      <Input required autoFocus
        className='part-quantity'
        name='partQuantity'
        type='number'
        size='small'
        min={1} max={9999}
        value={order.partQuantity}
        onChange={this.handleQuantityChange.bind(this, index)}
      />
    );
  }

  renderExtraColumns() {
    const {order, isSpecial} = this.props;

    if (!isSpecial) {
      return null;
    }

    return (
      <React.Fragment>
        <Table.Cell textAlign='center'>
          {order.user ? order.user.toUpperCase() : null}
        </Table.Cell>
        <Table.Cell textAlign='center'>{order.specialOrderCode}</Table.Cell>
      </React.Fragment>
    );
  }

  renderActions(order, index) {
    if (!order.active) {
      return (
        <React.Fragment>
          <Icon link size='large' color='blue' name='write' onClick={this.handleEditClick.bind(this, index)} />
          <Icon link size='large' color='red' name='delete' onClick={this.handleDeleteClick.bind(this, index)} />
        </React.Fragment>
      );
    }

    return (
      <React.Fragment>
        <SaveIcon index={index} order={order} />
        <Icon link size='large' color='red' name='close' onClick={this.handleCancelClick.bind(this, order, index)} />
      </React.Fragment>
    );
  }

  render() {
    const {order, index} = this.props;

    return (
      <Table.Row>
        <Table.Cell>
          <CodeInput order={order} index={index} />
        </Table.Cell>
        <Table.Cell>{order.description}</Table.Cell>
        <Table.Cell textAlign='right'>{this.renderQuantity(order, index)}</Table.Cell>
        <Table.Cell textAlign='right'>{order.confirmedBillQuantity}</Table.Cell>
        <Table.Cell textAlign='right'>{order.partProcessedQuantity}</Table.Cell>
        <Table.Cell>{order.status}</Table.Cell>
        <Table.Cell>{order.observation}</Table.Cell>
        <Table.Cell>{order.japanBill}</Table.Cell>
        {this.renderExtraColumns()}
        <Table.Cell textAlign='center'>{this.renderActions(order, index)}</Table.Cell>
      </Table.Row>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    'editing': state.providersOrdersManagementDetail.editing,
    'isSpecial': state.providersOrdersManagementDetail.isSpecial,
  };
};

const {
  editProviderOrderDetail,
  changeProviderDetailElementValue,
  removeProviderOrderDetailElement,
  editProviderOrderDetailElement,
  cancelProviderOrderDetailElementEdition,
  selectProviderOrderDetailElement,
} = Actions;

export default connect(mapStateToProps, {
  editProviderOrderDetail,
  changeProviderDetailElementValue,
  removeProviderOrderDetailElement,
  editProviderOrderDetailElement,
  cancelProviderOrderDetailElementEdition,
  selectProviderOrderDetailElement,
})(OrderElement);
